import { BROKERBANS_ADV } from './types';
// eslint-disable-next-line import/prefer-default-export
export var setBrokerBansAdvRedux = function (payload) { return ({
    type: BROKERBANS_ADV,
    payload: payload,
}); };
